var map = {
	"./add.svg": "c2a3",
	"./admin.svg": "ced6",
	"./alarm.svg": "3c85",
	"./back.svg": "c557",
	"./book.svg": "6ac0",
	"./cluster.svg": "60f5",
	"./company.svg": "9ef7",
	"./configMap.svg": "4670",
	"./container.svg": "7627",
	"./control.svg": "70d0",
	"./cost.svg": "ace1",
	"./cronJob.svg": "0754",
	"./daemonSet.svg": "f56a",
	"./dashboard.svg": "f782",
	"./delete.svg": "59a1",
	"./deployment.svg": "0762",
	"./doc.svg": "7ec4",
	"./edit.svg": "aa46",
	"./error.svg": "b1b9",
	"./folder.svg": "d079",
	"./group.svg": "a75f",
	"./history.svg": "c023",
	"./hotfix.svg": "1c68",
	"./image.svg": "8736",
	"./import.svg": "264a",
	"./ingress.svg": "6b2d",
	"./input.svg": "81d6",
	"./juyun.svg": "9dad",
	"./language.svg": "2580",
	"./logs.svg": "06a8",
	"./menu.svg": "bd3d",
	"./namespace.svg": "ef38",
	"./node.svg": "ad67",
	"./password.svg": "2a3d",
	"./pause.svg": "d46e",
	"./permission.svg": "3979",
	"./persistentVolume.svg": "605c",
	"./persistentVolumeClaims.svg": "104e",
	"./pod.svg": "76a1",
	"./refresh.svg": "b8c4",
	"./restart.svg": "8299",
	"./resume.svg": "a8b0",
	"./role.svg": "520c",
	"./rollback.svg": "e702",
	"./scale.svg": "3acd",
	"./search.svg": "8e8d",
	"./secret.svg": "a64c",
	"./service.svg": "4e04",
	"./slide.svg": "633e",
	"./star.svg": "708a",
	"./statefulSet.svg": "a005",
	"./storageClass.svg": "7036",
	"./success.svg": "a8cf",
	"./tag.svg": "f1fc",
	"./terminal.svg": "0243",
	"./tool.svg": "3495",
	"./unstar.svg": "90e2",
	"./update.svg": "6f6a",
	"./user.svg": "b3b5",
	"./warn.svg": "f809"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";